import React, { useEffect, useReducer } from 'react';
import { nedocsReducer, initialNedocs } from "../reducers";
import { hospitalActions } from "../actions";
import { BodyHomePageTotem } from '../components/BodyHomePageTotem';
import { useInternationalization } from '../hooks/useInternationalization';
import { Loader } from "../components/Loader";
import { useIntl } from 'react-intl';

export const HomePageTotem = ({ history }) => {
    const [nedocsStatus, updateNedocs] = useReducer(nedocsReducer, initialNedocs);

    const intl = useIntl();

    useEffect(() => {
        hospitalActions.hospitalNedocs("20700", updateNedocs, intl);
    }, [intl]);

    if (nedocsStatus.pristine || nedocsStatus.error) {
        return null;
    }

    if (nedocsStatus.loading) {
        return <Loader />;
    }

    return (
        <BodyHomePageTotem
            history={history}
            nedocsValue={nedocsStatus.nedocs.value}
        />
    );
}